import { Mongo } from 'meteor/mongo';
import { DeclareMethod } from '/imports/methods';
import { escapeRegExp } from '/imports/utils';
import { modelClass as cardModelClass, Card } from '/imports/api/cards';
import { Doc, ListMethodArg, ListMethodResponse, GetMethodResponse, ModelClass, References } from '/imports/types';

export interface Asset extends Doc {
  _id: string;
  botId: number;
  bot: string;
  cardId: number;
  card: string;
  typ: number;
  qty: number;
  tradeable: number;
  /** The card's set code, joined from the cardId reference at list time.
   *  Never stored on the asset -- a typed hook for the Set column. */
  set?: string;
}

type Model = Asset;
type Refs = References<Model, { cardId: Card }>;

export const Assets = new Mongo.Collection<Asset>('assets');

export const listAssets = DeclareMethod<ListMethodArg<Asset>, ListMethodResponse<Asset, Refs>>('listAssets');
export const getAsset = DeclareMethod<string, GetMethodResponse<Asset, Refs>>('getAsset');
export const createAsset = DeclareMethod<Partial<Asset>, string>('createAsset');
export const updateAsset = DeclareMethod<Partial<Asset>, string>('updateAsset');
export const deleteAsset = DeclareMethod<string, undefined>('deleteAsset');

export const modelClass: ModelClass<Model, Refs> = {
  collection: Assets,
  editableFields: ['botId', 'bot', 'cardId', 'card', 'typ', 'qty', 'tradeable'],
  // Join the card for its set code: listAssets returns $references.cardId
  // keyed by card id, and the Set column reads setName from it.
  references: { cardId: { modelClass: cardModelClass, fields: { setName: 1 } } },
  searchQuery: (search?: string) => {
    search = search?.trim();
    return search?.length
      ? { $or: [{ card: new RegExp(escapeRegExp(search), 'i') }, { bot: new RegExp(escapeRegExp(search), 'i') }] } as any
      : {};
  },
  listMethod: listAssets,
  getMethod: getAsset,
  createMethod: createAsset,
  updateMethod: updateAsset,
  deleteMethod: deleteAsset,
  pathPrefix: '/assets',
  modelName: 'Asset',
  pluralName: 'Assets',
};
